import { fetchFromObject } from 'helpers/object';

export default {
  data: state => field => fetchFromObject(state, field)
};
